import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cuestionario } from '../../_models/cuestionario';
import { CuestionarioPregunta } from '../../_models/cuestionario-pregunta';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { CuestionarioPreguntaService } from '../../_services/cuestionario-pregunta.service';
import { CuestionarioPreguntaRespuesta } from '../../_models/cuestionario-pregunta-respuesta';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CuestionarioPreguntaRespuestaService } from '../../_services/cuestionario-pregunta-respuesta.service';
import { RespuestaService } from '../../_services/respuesta.service';
import { PreguntaRespuesta } from '../../_models/pregunta-respuesta';

@Component( {
  selector: 'app-cuestionarios-pregunta-respuesta',
  templateUrl: 'cuestionarios-pregunta-respuesta.component.html'
} )

export class CuestionariosPreguntaRespuestaComponent implements OnInit {

  _cuestionario: Cuestionario;
  @Input() cuePregunta: CuestionarioPregunta;
  @Input() lisCuestionarioPregunta: CuestionarioPregunta[] = [];
  @Output() dismiss: EventEmitter<string> = new EventEmitter();
  seccion = 'L';
  columnas: any[] = [];
  formulario: FormGroup;
  forRespuesta: FormGroup;
  guardando = false;
  submitted = false;
  subRespuesta = false;
  guaRespuesta = false;
  resSeleccionada: CuestionarioPreguntaRespuesta;
  lisRespuesta: SelectItem[] = [];
  lisPreguntaDepende: SelectItem[] = [];
  carInformacionInicial = true;
  lisTodasRespuestas: PreguntaRespuesta[] = [];
  exiCorrecta = false;

  @Input()
  set cuestionario( cuestionario: Cuestionario ) {
    this._cuestionario = cuestionario;
    if ( this.forRespuesta ) {
      this.actualizarDepende();
    }
  }

  get cuestionario(): Cuestionario {
    return this._cuestionario;
  }

  constructor( private navServicio: NavService,
               private conServicio: ConfirmationService,
               private fb: FormBuilder,
               private cuePreguntaRespuestaServicio: CuestionarioPreguntaRespuestaService,
               private banPreguntasRespuestaServicio: RespuestaService,
               private cuePreguntaServicio: CuestionarioPreguntaService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'respuesta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_RESPUESTA' ), sort: false },
      { field: 'preguntaDepende', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_PREGUNTADEPENDE' ), sort: false },
      { field: 'indicadorCorrecta', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_CORRECTO' ), sort: false },
      { field: 'indicadorJustificacion', header: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.LBL_JUSTIFICACION' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];

    this.formulario = this.fb.group( {
      idCuestionarioPregunta: [ this.cuePregunta.idCuestionarioPregunta, [ Validators.required ] ],
      idCuestionario: [ this.cuePregunta.idCuestionario, [ Validators.required ] ],
      idPregunta: [ this.cuePregunta.idPregunta, [ Validators.required ] ],
      indicadorDescartante: [ this.cuePregunta.indicadorDescartante ? true : false ],
      orden: [ this.cuePregunta.orden, [ Validators.required ] ],
      indicadorHabilitado: [ this.cuePregunta ? this.cuePregunta.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.cuePregunta ? this.cuePregunta.auditoriaUsuario : null ],
      auditoriaFecha: [ this.cuePregunta ? this.cuePregunta.auditoriaFecha : null ],
    } );


    if ( this.cuePregunta.codigoTipoPregunta !== 'TEXTO' && this.cuePregunta.codigoTipoPregunta !== 'TIPOFE' ) {

      this.llenarPreguntasDepende();
      this.banPreguntasRespuestaServicio.listadoByPregunta( this.cuePregunta.idPregunta ).subscribe( respuestas => {
        this.lisTodasRespuestas = respuestas.filter( x => x.indicadorHabilitado );
        this.llenarRespuestas( true );
      } );
    } else {
      this.carInformacionInicial = false;
    }

  }

  llenarRespuestas( cargando?: boolean ) {
    this.lisRespuesta = [];
    this.lisTodasRespuestas.map( ( s: PreguntaRespuesta ) => {
      if ( !this.cuePregunta.respuestas.find( x => x.idRespuesta === s.idRespuesta ) ) {
        this.lisRespuesta.push( { label: s.nombre, value: s.idRespuesta } );
      }
    } );
    if ( cargando ) {
      this.carInformacionInicial = false;
    }
  }

  llenarPreguntasDepende() {
    this.lisPreguntaDepende = [];
    this.lisPreguntaDepende.push( { label: this.navServicio.buscarMensaje( 'LBL_SELECCIONE' ), value: null } );
    this.lisCuestionarioPregunta.map( ( s: CuestionarioPregunta ) => {
      if ( s.orden > this.cuePregunta.orden && !this.cuePregunta.respuestas.find( x => x.idPreguntaDepende === s.idCuestionarioPregunta && (!this.resSeleccionada || this.resSeleccionada.idCuestionarioPreguntaRespuesta !== x.idCuestionarioPreguntaRespuesta) ) ) {
        this.lisPreguntaDepende.push( { label: s.pregunta, value: s.idCuestionarioPregunta } );
      }
    } );
  }

  validarIndicadorCorrecto() {
    if ( this.cuePregunta.codigoTipoPregunta === 'SELECT' && this.cuePregunta.respuestas.find( x => x.indicadorCorrecta && (!this.resSeleccionada || this.resSeleccionada.idCuestionarioPreguntaRespuesta !== x.idCuestionarioPreguntaRespuesta) ) !== undefined ) {
      this.exiCorrecta = true;
      this.f.indicadorCorrecta.disable();
    } else {
      this.f.indicadorCorrecta.enable();
      this.exiCorrecta = false;
    }
  }

  llenarFormulario() {
    this.forRespuesta = this.fb.group( {
      idCuestionarioPreguntaRespuesta: [ this.resSeleccionada ? this.resSeleccionada.idCuestionarioPreguntaRespuesta : null ],
      idCuestionarioPregunta: [ this.resSeleccionada ? this.resSeleccionada.idCuestionarioPregunta : this.cuePregunta.idCuestionarioPregunta, [ Validators.required ] ],
      idRespuesta: [ this.resSeleccionada ? this.resSeleccionada.idRespuesta : null, [ Validators.required ] ],
      indicadorCorrecta: [ this.resSeleccionada ? this.resSeleccionada.indicadorCorrecta : false ],
      indicadorJustificacion: [ this.resSeleccionada ? this.resSeleccionada.indicadorJustificacion : false ],
      idPreguntaDepende: [ this.resSeleccionada ? this.resSeleccionada.idPreguntaDepende : null ],
      indicadorHabilitado: [ this.resSeleccionada ? this.resSeleccionada.indicadorHabilitado : true ],
      auditoriaUsuario: [ this.resSeleccionada ? this.resSeleccionada.auditoriaUsuario : null ],
      auditoriaFecha: [ this.resSeleccionada ? this.resSeleccionada.auditoriaFecha : null ],
      respuesta: [ this.resSeleccionada ? this.resSeleccionada.respuesta : null ],
      preguntaDepende: [ this.resSeleccionada ? this.resSeleccionada.preguntaDepende : null ],
    } );
  }

  nuevaRespuesta() {
    this.resSeleccionada = null;
    this.llenarFormulario();
    this.llenarPreguntasDepende();
    this.validarIndicadorCorrecto();
    this.subRespuesta = false;
    this.seccion = 'C';
  }

  inhabilitar( respuesta: CuestionarioPreguntaRespuesta ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'respuesta',
      accept: () => {
        this.carInformacionInicial = false;
        respuesta.indicadorHabilitado = false;
        this.cuePreguntaRespuestaServicio.actualizar( respuesta ).subscribe( actRegistro => {
          const indice = this.cuePregunta.respuestas.findIndex( x => x.idCuestionarioPreguntaRespuesta === respuesta.idCuestionarioPreguntaRespuesta );
          if ( indice >= 0 ) {
            this.cuePregunta.respuestas.splice( indice, 1 );
          }
          this.llenarRespuestas();
          this.llenarPreguntasDepende();
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );

  }

  actualizar( respuesta: CuestionarioPreguntaRespuesta ) {
    this.resSeleccionada = respuesta;
    this.subRespuesta = false;
    this.llenarFormulario();
    this.llenarPreguntasDepende();
    this.validarIndicadorCorrecto();
    this.seccion = 'E';
  }

  onSubmit() {
    const pregunta = this.formulario.getRawValue();
    const corExiste = this.cuePregunta.respuestas.find( x => x.indicadorCorrecta ) !== undefined ? true : false;
    if ( !pregunta.indicadorHabilitado || this.cuePregunta.codigoTipoPregunta === 'TEXTO' || this.cuePregunta.codigoTipoPregunta === 'TIPOFE' || corExiste ) {
      this.guardando = true;
      this.cuePreguntaServicio.actualizar( pregunta ).subscribe( preActualizada => {
        this.guardando = false;
        this.navServicio.setMesage( 2 );
        this.cuePregunta.indicadorDescartante = pregunta.indicadorDescartante;
        this.cuePregunta.indicadorHabilitado = pregunta.indicadorHabilitado;
        this.dismiss.emit( 'NL' );
      } );
    } else if ( this.cuePregunta.respuestas.length === 0 ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.MSG_NOEXISTEPREGUNTA' )
      } );
    } else if ( !corExiste ) {
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.MSG_NOEXISTECORRECTA' )
      } );
    }

  }

  regresar() {
    this.dismiss.emit( 'NL' );
  }

  actualizarRespuesta( respuesta: CuestionarioPreguntaRespuesta ) {
    this.cuePreguntaRespuestaServicio.actualizar( respuesta ).subscribe( regActualizar => {
      const b = this.lisCuestionarioPregunta.find( x => x.idCuestionarioPregunta === respuesta.idPreguntaDepende );
      if ( b ) {
        respuesta.preguntaDepende = b.pregunta;
      } else {
        respuesta.preguntaDepende = null;
      }

      const a = this.cuePregunta.respuestas.findIndex( x => x.idCuestionarioPreguntaRespuesta === respuesta.idCuestionarioPreguntaRespuesta );
      if ( a >= 0 ) {
        this.cuePregunta.respuestas[ a ] = respuesta;
      }
      this.guaRespuesta = false;
      this.navServicio.setMesage( 2 );
      this.seccion = 'L';
    } );
  }

  guardarRespuesta() {
    this.subRespuesta = true;
    if ( this.forRespuesta.valid ) {
      this.guaRespuesta = true;
      if ( this.f.idCuestionarioPreguntaRespuesta.value ) {
        const respuesta = this.forRespuesta.getRawValue();
        if ( (this.resSeleccionada.idPreguntaDepende !== '' && this.resSeleccionada.idPreguntaDepende !== null && this.resSeleccionada.idPreguntaDepende !== undefined) && !respuesta.idPreguntaDepende ) {
          this.conServicio.confirm( {
            message: this.navServicio.buscarMensaje( 'CUESTIONARIOPREGUNTA.MSG_CAMBIODEPENDENCIA' ),
            header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
            icon: 'fa fa-question-circle',
            key: 'respuesta',
            accept: () => {
              this.actualizarRespuesta( respuesta );
            },
            reject: () => {
            }
          } );
        } else {
          this.actualizarRespuesta( respuesta );
        }
      } else {
        const respuesta = this.forRespuesta.getRawValue();
        this.cuePreguntaRespuestaServicio.crear( respuesta ).subscribe( regActualizar => {
          respuesta.idCuestionarioPreguntaRespuesta = regActualizar.idCuestionarioPreguntaRespuesta;
          const a = this.lisTodasRespuestas.find( x => x.idRespuesta === respuesta.idRespuesta );
          if ( a ) {
            respuesta.respuesta = a.nombre;
          }
          const b = this.lisCuestionarioPregunta.find( x => x.idCuestionarioPregunta === respuesta.idPreguntaDepende );
          if ( b ) {
            respuesta.preguntaDepende = b.pregunta;
          } else {
            respuesta.preguntaDepende = null;
          }
          this.cuePregunta.respuestas.push( respuesta );
          this.llenarRespuestas();
          this.guaRespuesta = false;
          this.navServicio.setMesage( 1 );
          this.seccion = 'L';
        } );
      }
    }
  }

  get f() {
    return this.forRespuesta.controls;
  }

  regresarRespuesta( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'respuesta',
        accept: () => {
          this.seccion = 'L';
        },
        reject: () => {
        }
      } );
    } else {
      this.seccion = 'L';
    }
  }

  actualizarDepende() {
    if ( this.cuestionario.indicadorAzar ) {
      this.f.idPreguntaDepende.setValue( null );
    }
  }

}
